import {ApplicationRef, Injectable} from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import {AngularFireDatabase} from "angularfire2/database";
import {UiData} from "./ui-data";
import {ConnectivityService} from "../services/connectivity";
import {Storage} from "@ionic/storage";

declare var google: any;

@Injectable()
export class MissionsData {
    data: any;
    dataMap: any;
    searchFilters: any;
    lengthRanges:any;
    listLength: any;

    log: any;

    constructor(
        public http: Http,
        public userData: UserData,
        public uiData: UiData,
        public storage: Storage,
        public afDatabase: AngularFireDatabase,
        public connectivity: ConnectivityService,
        public application: ApplicationRef
    ) {
        this.listLength = 0;
    }
    getListLength()
    {
        return this.listLength;
    }
    refresh(): any {
        this.data = false;
        this.load("list");
        return this.load("map");
    }
    getMission(id):any {
        if(this.connectivity.isOnline())
        {
            var ref = this.afDatabase.object('appData/providers/missions/'+id).valueChanges();
            return ref;
        }
        else
        {
            var that = this;
            var promise = this.storage.get("application.providers.missions."+id);
            promise.then(function(data){
                return data;
            }).catch(function(){
                return false;
            });
            return Observable.fromPromise(
                promise
            );
        }
    }
    load(mode): any {
        this.log = Date.now();
        console.log(mode,this.log);
        if(mode == 'map')
        {
            if (this.dataMap) {
                return Observable.of(this.dataMap);
            } else {
                if(this.connectivity.isOnline())
                {
                    return this.afDatabase.list('appData/providers/missions_light',ref => ref.orderByChild('start_delay')).valueChanges().map(this.processDataMap, this);
                    //return this.afDatabase.list('appData/providers/missions',ref => ref.orderByChild('start_delay')).valueChanges().map(this.processDataMap, this);
                }
                else
                {
                    /*return Observable.fromPromise(
                        this.storage.get("application.providers.missions.map")
                    );*/
                    var that = this;
                    var promise = this.storage.get("application.providers.missions.map");
                    promise.then(function(data){
                        that.dataMap = data;
                    });
                    return Observable.fromPromise(
                        promise
                    );
                }
            }
        }
        else
        {
            if (this.data) {
                return Observable.of(this.data);
            } else {
                if(this.connectivity.isOnline())
                {
                    return this.afDatabase.list('appData/providers/missions_light',ref => ref.orderByChild('start_delay')).valueChanges().map(this.processData, this);
                    //return this.afDatabase.list('appData/providers/missions',ref => ref.orderByChild('start_delay')).valueChanges().map(this.processData, this);
                }
                else
                {
                    var that = this;
                    var promise = this.storage.get("application.providers.missions");
                    promise.then(function(data){
                        that.data = data;
                    });
                    return Observable.fromPromise(
                        promise
                    );
                }
            }
        }

    }
    processMission(data: any) {
        console.log('resolved',Date.now()-this.log);
        this.data = data;
        this.storage.set("application.providers.missions"+data.id,data);
        this.application.tick();
        return this.data;
    }
    processDataMap(data: any) {
        console.log('resolved',Date.now()-this.log);
        this.dataMap = data;
        this.storage.set("application.providers.missions.map",data);
        this.application.tick();
        return this.dataMap;
    }
    processData(data: any) {
        console.log('resolved',Date.now()-this.log);
        this.data = data;
        this.storage.set("application.providers.missions",data);
        this.application.tick();
        return this.data;
    }
    filterMission(mission,searchFilters,queryWords=[],boundaries = null)
    {

        let geoMatch = true;
        let queryMatch = true;

        let salaryMatch = true;
        let lengthMatch = true;

        let sectorMatch = true;

        let jobMatch = true;
        if(searchFilters) {
            if (searchFilters.location && searchFilters.location.enabled) {
                if (!boundaries) {
                    var orig = new google.maps.LatLng(searchFilters.location.lat, searchFilters.location.lng);
                    var dest = new google.maps.LatLng(mission.location_lat, mission.location_lng);

                    /* Calculate distance in meters */
                    var distance = google.maps.geometry.spherical.computeDistanceBetween(orig, dest);
                    var maxDistance = 200000;

                    if (searchFilters.location.distance && searchFilters.location.distance!=200) {
                        maxDistance = searchFilters.location.distance * 1000;
                    }
                    if (distance > maxDistance) geoMatch = false;
                }
                 else
                 {

                     // only display boundary visibles item on map
                     // mission.marker_visible
                     var ne = boundaries.getNorthEast(); // LatLng of the north-east corner
                     var sw = boundaries.getSouthWest(); // LatLng of the south-west corder
                     geoMatch = (mission.location_lat < ne.lat() && mission.location_lat > sw.lat()) &&
                         (mission.location_lng < ne.lng() && mission.location_lng > sw.lng())
                     ///mission.hide = true
                 }
            }
            if (queryWords) {
                queryMatch = false;
                if (queryWords.length) {
                    // of any query word is in the session name than it passes the query test
                    queryWords.forEach((queryWord: string) => {
                        if (mission.job.toLowerCase().indexOf(queryWord.toLowerCase()) > -1) {
                            queryMatch = true;
                        }
                    });
                } else {
                    // if there are no query words then this session passes the query test
                    queryMatch = true;
                }
            }
            if (searchFilters.length && searchFilters.length.enabled) {
                let min = this.lengthRanges[searchFilters.length.range.lower].data;
                let max = this.lengthRanges[searchFilters.length.range.upper].data;
                if (mission.total_days > max || mission.total_days < min) lengthMatch = false;
            }
            if (searchFilters.salary && searchFilters.salary.enabled) {
                if (mission.hour_price > searchFilters.salary.range.upper || mission.hour_price < searchFilters.salary.range.lower) salaryMatch = false;
            }
            if (searchFilters.job && searchFilters.job.enabled) {
                jobMatch = false;
                for (let i = 0; i < searchFilters.job.jobs.length; i++) {
                    if(mission.jobs && mission.jobs.length>0)
                    {
                        if(mission.jobs.indexOf(searchFilters.job.jobs[i])>=0)
                        {
                            jobMatch = true;
                        }
                    }
                    else
                    {
                        if (searchFilters.job.jobs[i] == mission.job) jobMatch = true;
                    }
                }
            }
            if (searchFilters.sector && searchFilters.sector.enabled) {
                if (!mission.job_category || !searchFilters.sector.sectors[mission.job_category]) sectorMatch = false;
            }
        }
        mission.hide = !(geoMatch && queryMatch && salaryMatch && lengthMatch && jobMatch && sectorMatch);

    }
    getList(searchFilters,queryText) {

        var queryWords = queryText.split(' ');
        if(queryText=="")queryWords=[];
        return this.load('list').map((data: any) => {
            this.lengthRanges = this.uiData.getLengthRanges();
            this.listLength = 0;
            this.log = Date.now();
            data.forEach((mission: any) => {
                // check if this session should show or not

                this.filterMission(mission, searchFilters, queryWords);
                if (!mission.hide) {
                    this.listLength++;
                }
            });
            //console.log('UPDATE '+searchFilters.order);
            if(searchFilters && searchFilters.order) {
                if (searchFilters.order == "paye") {
                    var res = data.sort(function (a, b) {
                        //if(a.hide || b.hide)return 0;
                        if (a.hour_price < b.hour_price) {
                            return 1;
                        }
                        else if (a.hour_price > b.hour_price) {
                            return -1;
                        }
                        else {
                            return 0;
                        }
                    });
                    return res;
                }
                else if (searchFilters.order == "paye-inv") {
                    var res =  data.sort(function (a, b) {
                        //if(a.hide || b.hide)return 0;
                        if (a.hour_price < b.hour_price) {
                            return -1;
                        }
                        else if (a.hour_price > b.hour_price) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    });
                    return res;
                }
                else if (searchFilters.order == "length") {
                    var res = data.sort(function (a, b) {
                        //if(a.hide || b.hide)return 0;
                        if (a.total_days < b.total_days) {
                            return 1;
                        }
                        else if (a.total_days > b.total_days) {
                            return -1;
                        }
                        else {
                            return 0;
                        }
                    });
                    return res;
                }
                else if (searchFilters.order == "length-inv") {
                    var res = data.sort(function (a, b) {
                        //if(a.hide || b.hide)return 0;
                        if (a.total_days > b.total_days) {
                            return 1;
                        }
                        else if (a.total_days < b.total_days) {
                            return -1;
                        }
                        else {
                            return 0;
                        }
                    });
                    return res;
                }
                else if (searchFilters.order == "location") {
                    var log_time = Date.now();

                    var res = data.sort(function (a, b) {
                        //if(a.hide || b.hide)return 0;

                        if (!a.dist) {
                            var orig = new google.maps.LatLng(searchFilters.location.lat, searchFilters.location.lng);
                            var dest = new google.maps.LatLng(a.location_lat, a.location_lng);
                            /* Calculate distance in meters */
                            a.dist = google.maps.geometry.spherical.computeDistanceBetween(orig, dest);
                        }
                        if (!b.dist) {
                            var orig = new google.maps.LatLng(searchFilters.location.lat, searchFilters.location.lng);
                            var dest = new google.maps.LatLng(b.location_lat, b.location_lng);
                            /* Calculate distance in meters */
                            b.dist = google.maps.geometry.spherical.computeDistanceBetween(orig, dest);
                        }

                        if (a.dist < b.dist) {
                            return -1;
                        }
                        else if (a.dist > b.dist) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    });
                    console.log('SORT',log_time-Date.now());
                    return res;
                }
                else {
                    var res = data.sort(function (a, b) {
                        //if(a.hide || b.hide)return 0;
                        if (a.start_delay < b.start_delay) {
                            return -1;
                        }
                        else if (a.start_delay > b.start_delay) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    });
                    return res;
                }
            }
            else
            {
                return data;
            }
        });
    }
    getMap(searchFilters,boundaries) {

        return this.load('map').map((data: any) => {
            this.lengthRanges = this.uiData.getLengthRanges();
            this.listLength = 0;
            data.forEach((mission: any) => {
                // check if this session should show or not
                this.filterMission(mission, searchFilters,[],boundaries);
                if (!mission.hide) {
                    this.listLength++;
                }
            });
            return data;
        });
    }

    setSearchFilters(values){
        this.userData.set('searchFilters',values);
    }

    getUserMissionsCandidates(){
        var returnArray = {
            'submitted': [],
            'refused': [],
            'canceled': [],
            'accepted': [],
            'signed': [],
            'visible':[]
        };
        var missions = this.userData.getAsArray('missionCandidates');
        for(let i=0;i < missions.length;i++)
        {
            let mission = missions[i];
            if(!returnArray[mission.status])returnArray[mission.status]=[];
            returnArray[mission.status].push(mission);

            if(mission.status!="signed")
            returnArray['visible'].push(mission);
        }
        return returnArray;
    }
    getUserMissionsContracts(){
        var returnArray = {
            'scheduled': [],
            'in-progress': [],
            'closed': [],
            'canceled': [],
            'visible': []
        };
        var missions = this.userData.getAsArray('missionContracts');
        for(let i=0;i < missions.length;i++)
        {
            let mission = missions[i];
            if(!returnArray[mission.missionStatus])returnArray[mission.missionStatus]=[];
            returnArray[mission.missionStatus].push(mission);

            returnArray['visible'].push(mission);
        }

        return returnArray;
    }
    setCheckin(data,chk,hours:any = false){

        var ymd = data.dateString.split('-');
        if(chk) {
            this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/state', 'checked-in');
        }
        else {
            this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/state', 'checked-out');
        }
    }
    setHours(data,hours:any = false){

        var ymd = data.dateString.split('-');
        if(hours)
        {
            if(hours.startHourString)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/startHourString', hours.startHourString);
            if(hours.endHourString)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/endHourString', hours.endHourString);
            if(hours.breakStartHourString)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/breakStartHourString', hours.breakStartHourString);
            if(hours.breakEndHourString)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/breakEndHourString', hours.breakEndHourString);

            if(hours && hours.state)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/state', hours.state);
            else
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/state', 'checked-out');

            if(hours && hours.hours)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/hours', hours.hours);

            if(hours && hours.reason)
                this.userData.set('missionPeriods/' + ymd[0] + '-' + ymd[1] + '/days/' + data.dateString + '/reason', hours.reason);
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/missions-data.ts